import { ArrowRight } from 'react-feather'

export type TocItem = { number: string; title: React.ReactNode }

type Props = {
  items: TocItem[]
  anchorPrefix?: string
}

export const TableOfContents = ({ items, anchorPrefix = 'benefit' }: Props) => (
  <div className="max-w-4xl mx-auto px-4 lg:px-8 py-12 lg:py-16">
    <div className="rounded-xl overflow-hidden border border-grey-200 shadow-sm">
      {/* Header */}
      <div className="flex justify-between items-center p-2 lg:p-4 bg-orange">
        <span className="text-white font-700 text-lg">Table of contents</span>
        <span className="text-white font-700 text-base hidden lg:block">
          Jump to section
        </span>
      </div>

      {/* Rows */}
      {items.map((item, i) => (
        <a
          key={item.number}
          href={`#${anchorPrefix}-${item.number}`}
          className={`flex items-center gap-2 lg:gap-4 p-2 lg:p-4 bg-white hover:bg-orange-100 transition-colors duration-300 ${
            i < items.length - 1 ? 'border-b border-grey-200' : ''
          }`}
        >
          <span className="w-8 h-8 rounded-full flex items-center justify-center flex-shrink-0 text-sm font-700 text-orange bg-orange-200 leading-none">
            {item.number}
          </span>
          <span className="flex-1 text-grey-900 text-base">{item.title}</span>
          <span className="text-orange flex-shrink-0 text-lg">
            <ArrowRight size={18} />
          </span>
        </a>
      ))}
    </div>
  </div>
)
